import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importa o componente Select
import Select from 'react-select';

class CertificationLanguagesTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
        overlay: {
            message: '',
            type: '',
            status: 'closed',        
        },
        redirect_url: false,
        loaded: 0,
        certification_languages: {},
        certifications: [],
        certification_id: this.props.certification_id,
        name: '',
        months_to_expire: '',
    };

    // Bind dos métodos
    this.add = this.add.bind(this);
    this.deleteLanguage = this.deleteLanguage.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && Array.isArray(newProps.certification_languages)) {
      this.setState({
        certification_languages: newProps.certification_languages,
        loaded: 1,
      });
    }
  }

  add(event) {
    event.preventDefault();
    var self = this;
    this.props.handleAlert('', '', 'open');

    var datasave = {
      certification_id: this.state.certification_id,
      name: this.state.name,
      months_to_expire: this.state.months_to_expire,
    };

    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/certificado/prova_idioma', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) })
        .then((response) => response.json())
        .catch((error) => { console.error(error); })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({
              certification_languages: responseJson.data,
              name: '', 
              months_to_expire: '', 
            });
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  deleteLanguage(event) {
    var certification_language_id = event.currentTarget.value;
    var confirmDelete = window.confirm('Tem certeza que gostaria de deletar essa replicação?');
    if (confirmDelete) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/certificado/prova_idioma/' + certification_language_id, { method: 'DELETE', mode: 'cors', headers: value })
          .then((response) => response.json())
          .catch((error) => { console.error(error); })
          .then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(certification_language_id);
            }
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          })
          .catch((error) => {
            console.error(error);
          });
      });
    }
  }

  deleteRow(certification_language_id) {
    var certification_languages = this.state.certification_languages.filter(function(dado) {
      return dado.id !== parseInt(certification_language_id);
    });
    this.setState({ certification_languages: certification_languages });
  }

  render() {
    var self = this;

    return (
      <div>
        <RequestApi ref={'request_api'} />
        <h4>Adicionar geração automática de prova de idioma</h4>
        <hr/>
        <form onSubmit={this.add}>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Idioma:</label>
              <Select
                className="form-field-name"
                name="name"
                value={this.state.name}
                searchable={true}
                onChange={this.handleSelectChange.bind(this, 'name')}
                options={[
                    {value: "INGLÊS", label: "Inglês"},
                    {value: "ALEMÃO", label: "Alemão"},
                    {value: "ESPANHOL", label: "Espanhol"},
                    {value: "FRANCÊS", label: "Francês"},
                    {value: "ITALIANO", label: "Italiano"},
                    {value: "ÁRABE", label: "Árabe"},
                    {value: "CHINÊS", label: "Chinês"},
                    {value: "JAPONÊS", label: "Japonês"},
                    {value: "RUSSO", label: "Russo"},
                    {value: "COREANO", label: "Coreano"},
                    {value: "HEBRAICO", label: "Hebraico"},
                    {value: "GREGO", label: "Grego"},
                    {value: "HOLANDÊS", label: "Holandês"},
                    {value: "SUECO", label: "Sueco"},
                    {value: "NORUEGUÊS", label: "Norueguês"},
                    {value: "DINAMARQUÊS", label: "Dinamarquês"},
                    {value: "FINLANDÊS", label: "Finlandês"},
                    {value: "ISLANDÊS", label: "Islandês"},
                    {value: "POLONÊS", label: "Polonês"},
                    {value: "TCHECO", label: "Tcheco"},
                ]}
              />
            </div>
            <div className="col-md-6 form-group">
              <label>Validade (em meses):</label>
              <input type="number" value={this.state.months_to_expire} name="months_to_expire" className="form-control" onChange={this.handleChange.bind(this, 'months_to_expire')} placeholder="Validade em meses da prova de idioma. Somente números." />
            </div>
          </div>
          <hr/>
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar geração de prova de idioma</button>
        </form>
        <hr/>
        <table className="table table-hover table-striped table-bordered">
          <thead>
            <tr>
              <th>Idioma</th>
              <th>Validade (em meses)</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(self.state.certification_languages).map(function(replication, index) {
              return (
                <tr key={index}>
                  <td>{self.state.certification_languages[replication].name}</td>
                  <td>{self.state.certification_languages[replication].months_to_expire}</td>
                  <td className="text-center">
                    <button className="btn btn-sm btn-danger" value={self.state.certification_languages[replication].id} onClick={self.deleteLanguage}>
                      <i className="fa fa-fw fa-trash"></i>
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
  
}

export default CertificationLanguagesTab;



// WEBPACK FOOTER //
// ./src/Components/Certifications/Elements/CertificationLanguagesTab.js